var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { asyncRouterMap } from '../../router';
import Vue from 'vue';
import { adminGroupsTypeListAPI } from '../../api/admin/role';
/**
 * 循环关键字检查权限
 * @param {*} permissions 权限关键数组
 * @param {*} authInfo
 */
var forCheckPermission = function (permissions, authInfo) {
    for (var index = 0; index < permissions.length; index++) {
        var key = permissions[index];
        authInfo = authInfo[key];
        if (!authInfo) {
            return false;
        }
        else if (permissions.length - 1 === index) {
            return true;
        }
    }
};
/**
 *
 */
function getAuthItem(array) {
    return array.find(function (item) {
        return item.name === 'manage-role-auth';
    });
}
/**
 * 获取角色列表
 * @param {*} authInfo 授权信息
 * @param {*} result 回调
 */
function getGroupData(authInfo, result) {
    if (authInfo && authInfo.manage && authInfo.manage.permission) {
        adminGroupsTypeListAPI().then(function (response) {
            if (result) {
                result({
                    requiresAuth: true,
                    list: response.data || []
                });
            }
        }).catch(function () { });
    }
    else {
        if (result) {
            result({
                requiresAuth: false
            });
        }
    }
}
/**
 *
 * @param {*} router
 * @param {*} authInfo
 */
function checkAuth(router, authInfo) {
    // 判断当前路由在权限数组中是否存在
    if (router.meta) {
        var metaInfo = router.meta;
        if (!metaInfo.requiresAuth) {
            return true;
        }
        else {
            if (metaInfo.permissions) {
                authInfo = __assign({}, authInfo);
                return forCheckPermission(metaInfo.permissions, authInfo);
            }
            else if (metaInfo.permissionList) { // 一个路由受多个权限判断
                for (var index = 0; index < metaInfo.permissionList.length; index++) {
                    authInfo = __assign({}, authInfo);
                    var permission_1 = forCheckPermission(metaInfo.permissionList[index], authInfo);
                    if (permission_1) {
                        return true;
                    }
                }
                return false;
            }
            else if (metaInfo.authFun) { // 方法 主要验证人资
                return metaInfo.authFun();
            }
        }
    }
    return true;
}
/**
 *
 * @param {*} routers
 * @param {*} authInfo
 */
var filterAsyncRouter = function (routers, authInfo) {
    var res = [];
    routers.forEach(function (router) {
        var tmp = __assign({}, router);
        if (checkAuth(tmp, authInfo)) {
            if (tmp.children) {
                tmp.children = filterAsyncRouter(tmp.children, authInfo);
            }
            res.push(tmp);
        }
    });
    return res;
};
/**
 * 忽略用于菜单展示的传参路由
 * @param {*} routers
 * @param {*} authInfo
 */
var filterIgnoreRouter = function (routers) {
    var res = [];
    routers.forEach(function (router) {
        var tmp = __assign({}, router);
        if (!tmp.ignore) {
            if (tmp.children) {
                tmp.children = filterIgnoreRouter(tmp.children);
            }
            res.push(tmp);
        }
    });
    return res;
};
/**
 * 路由重定向和角色路由完善
 */
var perfectRouter = function (authInfo, result) {
    getGroupData(authInfo, function (groupData) {
        var routerObj = {};
        var addRouter = [];
        var redirect = '';
        var topRedirect = ''; // 置顶的第一个路由
        for (var index = 0; index < asyncRouterMap.length; index++) {
            var mainRouter = asyncRouterMap[index];
            var accessedRouters = filterAsyncRouter(mainRouter.router, authInfo);
            for (var childIndex = 0; childIndex < accessedRouters.length; childIndex++) {
                var element = accessedRouters[childIndex];
                // 处理系统管理逻辑
                if (mainRouter.type === 'manage' && groupData.requiresAuth) {
                    var authItem = getAuthItem(accessedRouters);
                    var roleMenus = groupData.list.map(function (item) {
                        return {
                            name: 'role-auth',
                            path: "role-auth/" + item.roleType + "/" + encodeURI(item.name),
                            ignore: true,
                            meta: {
                                title: item.name
                            }
                        };
                    });
                    if (roleMenus && roleMenus.length > 0) {
                        var roleFirstChild = authItem.children[0];
                        roleFirstChild.meta.redirect = roleMenus[0].path;
                        authItem.children = authItem.children.concat(roleMenus);
                    }
                }
                if (element.children && element.children.length > 0) {
                    var firstChild = element.children[0];
                    var childPath = firstChild.meta ? firstChild.meta.redirect || firstChild.path : firstChild.path;
                    element.redirect = element.path + '/' + childPath;
                }
                // 获取跳转
                if (element.redirect) {
                    if (!redirect) {
                        redirect = element.redirect;
                    }
                    if (authInfo.wkFirstModel && !topRedirect) {
                        var modelName = {
                            crm: 'crm',
                            taskExamine: 'taskExamine',
                            log: 'workLog',
                            book: 'addressBook',
                            bi: 'bi',
                            calendar: 'calendar',
                            oa: 'oa'
                        }[authInfo.wkFirstModel];
                        if (modelName === mainRouter.type) {
                            topRedirect = element.redirect;
                        }
                    }
                    // 为导航头 获取每个模块的 重定向 url
                    accessedRouters.push({
                        path: "/" + mainRouter.type,
                        name: mainRouter.type,
                        redirect: element.redirect,
                        hidden: true
                    });
                    break;
                }
            }
            routerObj[mainRouter.type] = accessedRouters;
            addRouter = addRouter.concat(filterIgnoreRouter(accessedRouters));
        }
        if (redirect || topRedirect) {
            addRouter.push({
                path: '/',
                redirect: topRedirect || redirect,
                hidden: true
            });
        }
        if (result) {
            result({ router: routerObj, addRouter: addRouter });
        }
    });
};
var permission = {
    state: {
        addRouters: [],
        crmRouters: [],
        taskExamineRouters: [],
        workLogRouters: [],
        addressBookRouters: [],
        biRouters: [],
        manageRouters: [],
        oaRouters: [],
        fmRouters: []
    },
    mutations: {
        SET_ROUTERS: function (state, data) {
            state.addRouters = data.addRouter;
            state.crmRouters = data.router.crm || [];
            state.workLogRouters = data.router.workLog || [];
            state.taskExamineRouters = data.router.taskExamine || [];
            state.addressBookRouters = data.router.addressBook || [];
            state.biRouters = data.router.bi || [];
            state.manageRouters = data.router.manage || [];
            state.oaRouters = data.router.oa || [];
            state.fmRouters = data.router.fm || [];
        },
        /**
         * 客户管理待办消息数
         */
        SET_CRMROUTERSNUM: function (state, num) {
            var messageItem = state.crmRouters[1];
            messageItem.children[0].meta.num = num;
            Vue.set(state.crmRouters, 1, messageItem);
        },
        SET_GROUPSLIST: function (state, data) {
            state.groupsList = data;
        }
    },
    actions: {
        GenerateRoutes: function (_a, data) {
            var commit = _a.commit;
            return new Promise(function (resolve) {
                // 路由完善
                perfectRouter(data, function (routers) {
                    commit('SET_ROUTERS', routers);
                    resolve(data);
                });
            });
        }
    }
};
export default permission;
